
import { defineComponent, onMounted, ref } from 'vue'
import ContentLayout from '@/views/layout/ContentLayout.vue'
import { keieiJohoRepositories } from '@/repositories/keiei-joho/keieiJohoRepositories'
import LoadingButton from '@/views/components/LoadingButton.vue'
import DismissibleAlert from '@/views/components/DismissibleAlert.vue'
import { download, isBlob } from '@/views/utils'
import { hasMessage, isAxiosError } from '@/repositories/errorHandler'
import { apiErrorMessage } from '@/apiErrorMessage'
import { callApiWrapper } from '@/views/callApiWrapper'
import { FacilityInfoPick } from '@/repositories/keiei-joho/keiei-joho/keieiJohoExportRepository'

const repository = keieiJohoRepositories.keieiJohoExport

export default defineComponent({
  components: {
    DismissibleAlert,
    LoadingButton,
    ContentLayout
  },
  setup () {
    const errorMessage = ref<string | null>(null)
    const loading = ref(false)

    const facilityPicks = ref<FacilityInfoPick[]>([])
    const selectedFacilities = ref<FacilityInfoPick[]>([])

    onMounted(async () => {
      loading.value = true
      await callApiWrapper(errorMessage, async () => {
        const hasData = await repository.checkDataExists()
        if (!hasData.hasCorporationInfo) {
          errorMessage.value = '法人情報が登録されていません。法人情報画面から登録してください。'
          loading.value = false
          return
        }
        if (!hasData.hasFacilityInfo) {
          errorMessage.value = '施設情報が登録されていません。法人情報画面から登録してください。'
          loading.value = false
          return
        }
        facilityPicks.value = await repository.getFacilityInfoPick()
      })
      loading.value = false
    })

    const onClickedExport = async () => {
      loading.value = true

      if (selectedFacilities.value.length === 0) {
        errorMessage.value = '施設情報を選択してください。'
        loading.value = false
        return
      }

      try {
        const facilityKeyList = selectedFacilities.value.map(v => v.facilityKey)
        const response = await repository.export(facilityKeyList)
        download(response)
      } catch (e) {
        if (isAxiosError(e)) {
          if (e.response && e.response.status >= 400 && e.response.headers['content-type'] === 'application/json') {
            if (isBlob(e.response.data)) {
              const json = await e.response.data.text()
              const jsonObj = JSON.parse(json)
              if (hasMessage(jsonObj)) {
                errorMessage.value = jsonObj.message
              }
            }
          }
        }
        if (errorMessage.value === null) {
          errorMessage.value = apiErrorMessage.badRequest
        }
      } finally {
        loading.value = false
      }
    }

    return {
      onClickedExport,
      loading,
      errorMessage,
      facilityPicks,
      selectedFacilities
    }
  }
})
